import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

type CardProps = React.HTMLAttributes<HTMLDivElement>

const Card = ({ className, ...props }: CardProps, ref) => {
  const classes = useStyles()

  return <div ref={ref} {...props} className={clsx(classes.root, className)} />
}

export default React.forwardRef<HTMLDivElement, CardProps>(Card)
